import { Fragment } from '@integrations/react'
import PromoBanner, { type PromoItem } from './PromoBanner'
import { useIbanPromo } from './useIbanPromo'
import { useReferralPromo } from './useReferralPromo'

/**
 * Collects every promo the current merchant is eligible for and hands them to the dashboard's
 * single banner slot, highest-value first. The IBAN request wizard renders as an independent
 * sibling of the banner so a later `accountsFetching` flip can hide the banner without
 * unmounting an already-open flow (PLAT-16471).
 */
function DashboardPromos() {
  const { promo: ibanPromo, flow: ibanFlow } = useIbanPromo()
  const referralPromo = useReferralPromo()

  const promos = [ibanPromo, referralPromo].filter((promo): promo is PromoItem => promo !== null)

  return (
    <Fragment>
      <PromoBanner promos={promos} />
      {ibanFlow}
    </Fragment>
  )
}

export default DashboardPromos
